var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"realTimeStatusPage mainPageBg"},[_c('div',{staticClass:"leftMenuBox"},[_c('TreeMenu',{attrs:{"pageName":'动力系统'},on:{"getActiveItem":_vm.getActiveItem}})],1),_c('div',{staticClass:"contentBox"},[_c('div',{staticClass:"leftBox",style:({
        width:
          _vm.activeTree.type == '项目' || _vm.activeTree.type == '区域资产'
            ? '100%'
            : '75%',
      })},[_c('StateCenterCom',{attrs:{"activeTree":_vm.activeTree}})],1),(_vm.activeTree.type != '项目' && _vm.activeTree.type != '区域资产')?_c('div',{staticClass:"rightBox"},[_c('ElevatorArchives',{attrs:{"activeTree":_vm.activeTree}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }